/* eslint-disable @typescript-eslint/no-explicit-any */
import { AuthenticationService, ISecurityConfig } from '@eta/components';

export const securityConfig: ISecurityConfig = {
    stsAuthority: (window as any).REACT_APP_stsAuthority,
    clientId: (window as any).REACT_APP_clientId,
    clientScope: (window as any).REACT_APP_clientScope,
    clientRoot: (window as any).REACT_APP_clientRoot,
    defaultPath: './home',
    logoutSync: true
};
export const authService = new AuthenticationService(securityConfig);
